module.exports = __webpack_public_path__ + "static/media/lpu-retouched.bb03911e.png";